export const OPTIONS = {
  ['Etc/GMT-1']: 'GMT +1',
  ['Etc/GMT-2']: 'GMT +2',
  ['Etc/GMT-3']: 'GMT +3',
  ['Etc/GMT-4']: 'GMT +4',
  ['Etc/GMT-5']: 'GMT +5',
  ['Etc/GMT-6']: 'GMT +6',
  ['Etc/GMT-7']: 'GMT +7',
  ['Etc/GMT-8']: 'GMT +8',
  ['Etc/GMT-9']: 'GMT +9',
  ['Etc/GMT-10']: 'GMT +10',
} as const;

export type GmtValue = keyof typeof OPTIONS;

const DEFAULT_VALUE = 'Etc/GMT-3' satisfies GmtValue;

function isGmtValue(str: string): str is GmtValue {
  //@ts-expect-error non-typable
  return str in OPTIONS && Boolean(OPTIONS[str]);
}

export const coerceGmtValue = (str: string): GmtValue => {
  if (isGmtValue(str)) {
    return str;
  } else {
    return DEFAULT_VALUE;
  }
};
